<ion-header>
  <ion-toolbar color="light">
    <ion-buttons slot="start">
      <ion-button (click)="dismissModal()">
        <ion-icon class="back-icon" name="chevron-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      <app-offline-indicator></app-offline-indicator>
      {{ 'ACCOUNT.lbl.list' | translate }}
    </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content color="light">
  <div class="full-width-height viewport-div" *ngIf="userAccountsList?.length">
    <cdk-virtual-scroll-viewport [itemSize]="48">
      <ion-list class="full-width-height background-transparent ion-padding-bottom" lines="none" #list>
        <ion-item-sliding *cdkVirtualFor="let userAccounts of userAccountsList; trackBy: trackByFn; let i = index;" #slidingItem>
          <ion-item class="item" [color]="checkSelected(userAccounts?.accountId) ? 'tertiary' : 'white'" (click)="select(userAccounts)">
            <ion-label class="font-14 ion-no-margin">
              {{ userAccounts.title.value }}
            </ion-label>
            <ion-text slot="end" *ngIf="checkSelected(userAccounts?.accountId)">
              <ion-icon name="checkmark-outline"></ion-icon>
            </ion-text>
          </ion-item>
        </ion-item-sliding>
      </ion-list>
    </cdk-virtual-scroll-viewport>
  </div>

  <div class="full-width-height vertical-center center ion-margin" *ngIf="!userAccountsList?.length">
    <ion-label class="ion-text-center ion-margin ion-padding" color="medium">
      <ion-icon class="center icon-cactus" src="./assets/wedding/icon/general/no-record.svg"></ion-icon>
      <div class="ion-margin-top font-14">{{ 'LBL.no_found' | translate }}</div>
    </ion-label>
  </div>
</ion-content>
